document.getElementById("sizeChartLink").onclick = function(event) {
  event.preventDefault();
  document.getElementById("sizeChartModal").style.display = "block";
  document.body.style.overflow = "hidden";  // Disable scrolling
};

document.querySelector(".size-chart-modal-close").onclick = function() {
  document.getElementById("sizeChartModal").style.display = "none";
  document.body.style.overflow = "auto";  // Re-enable scrolling
};

window.onclick = function(event) {
  if (event.target === document.getElementById("sizeChartModal")) {
    document.getElementById("sizeChartModal").style.display = "none";
    document.body.style.overflow = "auto";  // Re-enable scrolling
  }
};
